export const MONTHS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août'];
export const MAX_DAYS = 31;
export const WEEKS_PER_YEAR = 52;
